import { Component, inject, OnInit } from '@angular/core';
import { UnsubscribeOnDestroy } from '../../classes';
import { SpinnerService } from '../../services';
import { takeUntil } from 'rxjs';


@Component({
    selector: 'spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.scss'],
    standalone: true,
    imports: []
})
export class SpinnerComponent extends UnsubscribeOnDestroy implements OnInit {
    private spinnerService = inject(SpinnerService);
    showSpinner: boolean = false;
    spinnerMessages: string[] = [];

    constructor() { super(); }

    ngOnInit(): void {
        this.spinnerService.updateMessages
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe((val) => {
                this.spinnerMessages = val;
            });

        this.spinnerService.showSpinner
            .pipe(takeUntil(this.ngUnsubscribe$))
          .subscribe((val) => {
            if (val) {
              this.show();
            } else {
              this.hide();
            }
            });
    }

    show(): void {
        this.showSpinner = true;
    }

    hide(): void {
        this.showSpinner = false;
    }
}
